import React, { memo, forwardRef } from "react";
const SvgVector = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M28.028 9.778c.648 2.016.972 4.077.972 6.183s-.324 4.176-.972 6.21c-.648 2.016-1.503 3.78-2.565 5.292-.216.306-.468.459-.756.459a.808.808 0 01-.594-.243.722.722 0 01-.243-.567c0-.18.072-.387.216-.621.954-1.476 1.71-3.132 2.268-4.968.576-1.836.864-3.69.864-5.562 0-1.872-.288-3.726-.864-5.562-.558-1.836-1.314-3.492-2.268-4.968-.144-.234-.216-.441-.216-.621 0-.234.081-.423.243-.567A.808.808 0 0124.707 4c.288 0 .54.153.756.459 1.062 1.512 1.917 3.285 2.565 5.319zM3.972 22.171A20.341 20.341 0 013 15.961c0-2.106.324-4.167.972-6.183.648-2.034 1.503-3.807 2.565-5.319.216-.306.468-.459.756-.459.234 0 .432.081.594.243a.722.722 0 01.243.567c0 .18-.072.387-.216.621-.954 1.476-1.719 3.132-2.295 4.968a19.031 19.031 0 00-.837 5.562c0 1.872.279 3.726.837 5.562.576 1.836 1.341 3.492 2.295 4.968.144.234.216.441.216.621a.722.722 0 01-.243.567.808.808 0 01-.594.243c-.288 0-.54-.153-.756-.459-1.062-1.512-1.917-3.276-2.565-5.292z"
      />
      <path
        fill="#DBDBDB"
        d="M18 4.737h-4c-.552 0-1 .299-1 .667v4.666c0 .369.448.667 1 .667h4c.552 0 1-.298 1-.667V5.404c0-.368-.448-.667-1-.667zM18 12.737h-4c-.552 0-1 .299-1 .667v4.666c0 .369.448.667 1 .667h4c.552 0 1-.298 1-.667v-4.666c0-.368-.448-.667-1-.667zM18 20.737h-4c-.552 0-1 .299-1 .667v4.666c0 .369.448.667 1 .667h4c.552 0 1-.298 1-.667v-4.666c0-.369-.448-.667-1-.667z"
      />
    </svg>
  );
});
SvgVector.displayName = "SvgVector";
const MemoForwardRef = memo(SvgVector);
export default MemoForwardRef;
